import React, { useState, useEffect } from 'react';
import { Segmented, Space, Popover, Row } from 'antd';
import ToggleButton from '@mui/material/ToggleButton';
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { CameraOutlined } from "@ant-design/icons";
import DateRange from '../../Components/DateRange';
import {RestoreRounded, ZoomOutMapRounded, FullscreenRounded, CachedRounded, CalendarMonthOutlined} from "@mui/icons-material";


const ButtonIcon = ({label})=>{
    switch(label){
        case '1Y':
        case '3Y':
        case '5Y':
            return <RestoreRounded />;
        case 'Max':
            return <CachedRounded />;
        case 'Fullscreen':
            return <ZoomOutMapRounded/>;
        default:
            return null
    }
}

const RangeSelector = ({ years, globalMin, globalMax, onYearSelected, onFullscreen, selectedRange,
                         onScreenshot, extra }) => {
  const [selectedOption, setSelectedOption] = useState('max');
  const [isXlScreen, setIsXlScreen] = useState(window.innerWidth >= 1200);

  useEffect(() => {
    const handleResize = () => {
      setIsXlScreen(window.innerWidth >= 1200);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelection = (value) => {
    setSelectedOption(value);
    let start, end;
    switch (value) {
        case '1_y':
            start = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
            start.setDate(start.getDate() - 1); // Subtract one additional day
            end = new Date();
            break;
        case '3_y':
            start = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
            start.setDate(start.getDate() - 1); // Subtract one additional day
            end = new Date();
            break;
        case '5_y':
            start = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
            start.setDate(start.getDate() - 1); // Subtract one additional day
            end = new Date();
            break;
        case 'max':
            start = new Date(globalMin);
            end = new Date(globalMax);
            break;
        default:
            start = new Date(value-1, 11, 27);
            end = new Date(value, 11, 31);
            break;
    }
    onYearSelected({start: start.getTime(), end: end.getTime()});
  };

  const options = [
    { label: 'Max', value: 'max' },
    { label: '1Y', value: '1_y' },
    { label: '3Y', value: '3_y' },
    { label: '5Y', value: '5_y' },
    ...years.map(year => ({ label: year.toString(), value: year.toString() }))
  ];
  if (onFullscreen) {
    options.unshift({ label: 'Fullscreen', value: 'fullscreen' });
  }

  const popoverContent = (
    <Segmented
      options={options}
      value={selectedOption}
      onChange={(value) => {
        handleSelection(value);
        if (value === 'fullscreen') {
          onFullscreen();
        }
      }}
    />
  );

  return (
    <Row justify={'end'}>
      <Space>
          {extra}

        {isXlScreen ? (

            <ButtonGroup
                  size={'small'}
                  color={'inherit'}
                  exclusive
                  variant={'outlined'}
                  value={selectedOption}
                >
                  {options.map(option => (
                    <Button
                        onClick={()=>handleSelection(option.value)}
                        startIcon={<ButtonIcon label={option.label}/>}
                        key={option.value} value={option.value}>{option.label}</Button>
                  ))}
            </ButtonGroup>
        ) : (
          <Popover content={popoverContent} title="Select Year" trigger="hover">
            <Button>{selectedOption}</Button>
          </Popover>
        )}
        <DateRange
          className={'small'}
          startDate={selectedRange.start}
          endDate={selectedRange.end}
          minDate={globalMin}
          maxDate={globalMax}
          onDateRangeChange={(start, end)=>onYearSelected({start, end})}
        />
        {onScreenshot && (
            <Button onClick={onScreenshot} icon={<CameraOutlined/>}/>
        )}
      </Space>
    </Row>
  );
};

export default RangeSelector;
